"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _FormElementError = _interopRequireDefault(require("../Form/FormElementError"));

var _Label = _interopRequireDefault(require("../Label/Label"));

var _TextButton = _interopRequireDefault(require("../TextButton/TextButton"));

var _TextInput = _interopRequireDefault(require("../TextInput/TextInput"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var PasswordControl =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PasswordControl, _Component);

  function PasswordControl(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PasswordControl);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PasswordControl).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      showPassword: false,
      isValid: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onPasswordFocus", function () {
      var onFocus = _this.props.onFocus;

      if (onFocus) {
        onFocus();
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onPasswordChange", function (evt) {
      _this.setState({
        value: evt.target.value,
        isValid: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onInvalid", function (validationState) {
      var onInvalid = _this.props.onInvalid;

      _this.setState({
        isValid: validationState.valid
      });

      if (onInvalid) {
        onInvalid(validationState);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "_onToggleShowPasswordChange", function () {
      _this._generateKey();

      _this.setState(function (prevState, props) {
        return {
          showPassword: !prevState.showPassword
        };
      });
    });
    var requiredError = props.requiredError,
        minLength = props.minLength;
    _this._pattern = minLength ? ".{".concat(minLength, ",}") : null;

    if (minLength) {
      _this._error = _react.default.createElement(_FormElementError.default, null, "Please enter at least ", minLength, " characters.");
    } else {
      _this._error = _react.default.createElement(_FormElementError.default, null, requiredError);
    }

    _this._generateKey();

    return _this;
  }

  (0, _createClass2.default)(PasswordControl, [{
    key: "_generateKey",
    value: function _generateKey() {
      this._key = "password-".concat(Date.now());
    }
    /**
     * Provides the form data as an object for submission.
     *
     * @public
     * @returns {Object} - The form data to submit.
     */

  }, {
    key: "submit",
    value: function submit() {
      var value = this._input.node.value;
      return value ? {
        password: value
      } : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          showCheckboxId = _this$props.showCheckboxId,
          showForgotPassword = _this$props.showForgotPassword,
          label = _this$props.label,
          placeholder = _this$props.placeholder,
          showPlaceholder = _this$props.showPlaceholder,
          helpNode = _this$props.helpNode,
          required = _this$props.required,
          onForgotPasswordClick = _this$props.onForgotPasswordClick;
      var _this$state = this.state,
          value = _this$state.value,
          showPassword = _this$state.showPassword,
          isValid = _this$state.isValid;
      var classes = (0, _classnames.default)('PasswordControl', 'FormElement', {
        'FormElement-contains-error': !isValid
      }, className);
      return _react.default.createElement("div", {
        className: classes
      }, label, _react.default.createElement("div", {
        className: "PasswordControl-input"
      }, _react.default.createElement(_TextInput.default, {
        key: this._key,
        ref: function ref(node) {
          _this2._input = node;
        },
        name: "password",
        type: showPassword ? 'text' : 'password',
        required: required,
        pattern: this._pattern,
        defaultValue: value,
        placeholder: showPlaceholder && placeholder ? placeholder : '',
        onChange: this._onPasswordChange,
        onInvalid: this._onInvalid,
        onFocus: this._onPasswordFocus
      }), _react.default.createElement("div", {
        className: "PasswordControl-show"
      }, _react.default.createElement(_Checkbox.default, {
        id: showCheckboxId,
        label: _react.default.createElement(_Label.default, null, "Show"),
        onChange: this._onToggleShowPasswordChange
      }), _react.default.createElement(_TextButton.default, {
        onClick: this._onToggleShowPasswordChange
      }, showPassword ? 'Hide' : 'Show'))), helpNode && _react.default.createElement("div", {
        className: "FormElement-help-text"
      }, helpNode), !isValid && this._error, showForgotPassword && _react.default.createElement(_TextButton.default, {
        className: "PasswordControl-forgot",
        onClick: onForgotPasswordClick
      }, "Forgot Password?"));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return PasswordControl;
}(_react.Component);

exports.default = PasswordControl;
(0, _defineProperty2.default)(PasswordControl, "propTypes", {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** A unique ID which is used to identify the show password Checkbox for accessibility purposes on the client as well as the server. */
  showCheckboxId: _propTypes.default.string,

  /** Whether to show the Forgot Password button. */
  showForgotPassword: _propTypes.default.bool,

  /** A custom label (typically a Label component) to display above the input. */
  label: _propTypes.default.element,

  /** Text to display in the field before a user starts to type in the input. */
  placeholder: _propTypes.default.string,

  /** Whether to show the placeholder copy or not. */
  showPlaceholder: _propTypes.default.bool,

  /** Whether this field is required during validation. */
  required: _propTypes.default.bool,

  /** The error to show when required validation fails. */
  requiredError: _propTypes.default.string,

  /** A custom help element to place below the input. */
  helpNode: _propTypes.default.node,

  /** Specifies the minimum number of characters allowed if a minimum password length is desired. */
  minLength: _propTypes.default.number,

  /** Function to execute when the iForgot Password button is clicked. */
  onForgotPasswordClick: _propTypes.default.func,

  /**
   * Function to execute when the input is focused.
   *
   * @param {SyntheticEvent} evt - The React `SyntheticEvent`.
   */
  onFocus: _propTypes.default.func,

  /**
   * Function to execute when the element is marked as invalid by a validation check.
   *
   * @param {ValidityState} validationState - ValidityState object for more fine grained control over error handling in a parent component if desired.
   */
  onInvalid: _propTypes.default.func
});
(0, _defineProperty2.default)(PasswordControl, "defaultProps", {
  showCheckboxId: 'PasswordControl-show-password',
  showForgotPassword: true,
  required: true,
  requiredError: 'Please enter your password.'
});
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PasswordControl, "PasswordControl", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/PasswordControl/PasswordControl.jsx");
  leaveModule(module);
})();

;